// source: witbooking/backoffice/orchestrator/experiment/v1/experiment_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.DiffUnit', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.Granularity', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.Variant', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.VariantRole', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.VariantType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.experiment.v1.Verdict', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.Variant, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.Variant';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.displayName = 'proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    experiment: (f = msg.getExperiment()) && proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.deserializeBinaryFromReader);
      msg.setExperiment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExperiment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Experiment experiment = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.prototype.getExperiment = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.prototype.setExperiment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.prototype.clearExperiment = function() {
  return this.setExperiment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.prototype.hasExperiment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    experimentsList: jspb.Message.toObjectList(msg.getExperimentsList(),
    proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.deserializeBinaryFromReader);
      msg.addExperiments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExperimentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Experiment experiments = 1;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment>}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.prototype.getExperimentsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment>} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.prototype.setExperimentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.prototype.addExperiments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.prototype.clearExperimentsList = function() {
  return this.setExperimentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    experiment: (f = msg.getExperiment()) && proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.deserializeBinaryFromReader);
      msg.setExperiment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExperiment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Experiment experiment = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.prototype.getExperiment = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.prototype.setExperiment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.prototype.clearExperiment = function() {
  return this.setExperiment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest.prototype.hasExperiment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    experiment: (f = msg.getExperiment()) && proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.deserializeBinaryFromReader);
      msg.setExperiment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExperiment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Experiment experiment = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.prototype.getExperiment = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.prototype.setExperiment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.prototype.clearExperiment = function() {
  return this.setExperiment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.prototype.hasExperiment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    experiment: (f = msg.getExperiment()) && proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.deserializeBinaryFromReader);
      msg.setExperiment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExperiment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Experiment experiment = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.prototype.getExperiment = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.prototype.setExperiment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.prototype.clearExperiment = function() {
  return this.setExperiment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest.prototype.hasExperiment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    after: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAfter();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string after = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.prototype.getAfter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest.prototype.setAfter = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    targetPath: jspb.Message.getFieldWithDefault(msg, 4, ""),
    startedAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    variantsList: jspb.Message.toObjectList(msg.getVariantsList(),
    proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.toObject, includeInstance),
    createdAt: jspb.Message.getFieldWithDefault(msg, 7, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
    description: jspb.Message.getFieldWithDefault(msg, 9, ""),
    estimatedEndDate: jspb.Message.getFieldWithDefault(msg, 11, 0),
    deletedAt: jspb.Message.getFieldWithDefault(msg, 12, 0),
    mde: jspb.Message.getFieldWithDefault(msg, 13, 0),
    minDays: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetPath(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartedAt(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.Variant;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.deserializeBinaryFromReader);
      msg.addVariants(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEstimatedEndDate(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeletedAt(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMde(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinDays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTargetPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStartedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getVariantsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEstimatedEndDate();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getDeletedAt();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getMde();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getMinDays();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ExperimentStatus status = 3;
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getStatus = function() {
  return /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string target_path = 4;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getTargetPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setTargetPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 started_at = 5;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getStartedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setStartedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated Variant variants = 6;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant>}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getVariantsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.Variant, 6));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant>} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setVariantsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.addVariants = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.witbooking.backoffice.orchestrator.experiment.v1.Variant, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.clearVariantsList = function() {
  return this.setVariantsList([]);
};


/**
 * optional int64 created_at = 7;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 updated_at = 8;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string description = 9;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 estimated_end_date = 11;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getEstimatedEndDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setEstimatedEndDate = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 deleted_at = 12;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getDeletedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setDeletedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 mde = 13;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getMde = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setMde = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 min_days = 14;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.getMinDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.prototype.setMinDays = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0),
    scenarioId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    url: jspb.Message.getFieldWithDefault(msg, 5, ""),
    trafficSplit: jspb.Message.getFieldWithDefault(msg, 6, 0),
    scenarioTicker: jspb.Message.getFieldWithDefault(msg, 7, ""),
    role: jspb.Message.getFieldWithDefault(msg, 8, 0),
    isEngineDefault: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.Variant;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.VariantType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setScenarioId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrafficSplit(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setScenarioTicker(value);
      break;
    case 8:
      var value = /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.VariantRole} */ (reader.readEnum());
      msg.setRole(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEngineDefault(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getScenarioId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTrafficSplit();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getScenarioTicker();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getIsEngineDefault();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional VariantType type = 3;
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.VariantType}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.getType = function() {
  return /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.VariantType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.VariantType} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string scenario_id = 4;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.getScenarioId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.setScenarioId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string url = 5;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 traffic_split = 6;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.getTrafficSplit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.setTrafficSplit = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string scenario_ticker = 7;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.getScenarioTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.setScenarioTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional VariantRole role = 8;
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.VariantRole}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.getRole = function() {
  return /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.VariantRole} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.VariantRole} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional bool is_engine_default = 9;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.getIsEngineDefault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Variant} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Variant.prototype.setIsEngineDefault = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tickerContains: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    startedAtFrom: jspb.Message.getFieldWithDefault(msg, 3, 0),
    startedAtTo: jspb.Message.getFieldWithDefault(msg, 4, 0),
    minDurationDays: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTickerContains(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartedAtFrom(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartedAtTo(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinDurationDays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTickerContains();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStartedAtFrom();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getStartedAtTo();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getMinDurationDays();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string ticker_contains = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.prototype.getTickerContains = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.prototype.setTickerContains = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ExperimentStatus status = 2;
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.prototype.getStatus = function() {
  return /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 started_at_from = 3;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.prototype.getStartedAtFrom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.prototype.setStartedAtFrom = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 started_at_to = 4;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.prototype.getStartedAtTo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.prototype.setStartedAtTo = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 min_duration_days = 5;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.prototype.getMinDurationDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest.prototype.setMinDurationDays = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ExperimentListItem items = 1;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem>}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem>} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    experiment: (f = msg.getExperiment()) && proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.toObject(includeInstance, f),
    lift: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    hasLift: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    confidence: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    isReliable: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    activeDays: jspb.Message.getFieldWithDefault(msg, 6, 0),
    liftTooltipKey: jspb.Message.getFieldWithDefault(msg, 7, ""),
    pausedSeconds: jspb.Message.getFieldWithDefault(msg, 8, 0),
    sampleProgress: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.deserializeBinaryFromReader);
      msg.setExperiment(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLift(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasLift(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConfidence(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsReliable(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActiveDays(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiftTooltipKey(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPausedSeconds(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSampleProgress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExperiment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.serializeBinaryToWriter
    );
  }
  f = message.getLift();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getHasLift();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getConfidence();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getIsReliable();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getActiveDays();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getLiftTooltipKey();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPausedSeconds();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getSampleProgress();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
};


/**
 * optional Experiment experiment = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.getExperiment = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.setExperiment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.clearExperiment = function() {
  return this.setExperiment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.hasExperiment = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double lift = 2;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.getLift = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.setLift = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional bool has_lift = 3;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.getHasLift = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.setHasLift = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional double confidence = 4;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.getConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional bool is_reliable = 5;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.getIsReliable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.setIsReliable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int32 active_days = 6;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.getActiveDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.setActiveDays = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string lift_tooltip_key = 7;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.getLiftTooltipKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.setLiftTooltipKey = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 paused_seconds = 8;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.getPausedSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.setPausedSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double sample_progress = 9;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.getSampleProgress = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentListItem.prototype.setSampleProgress = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    experimentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    newStatus: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExperimentId(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus} */ (reader.readEnum());
      msg.setNewStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExperimentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNewStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string experiment_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.prototype.getExperimentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.prototype.setExperimentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ExperimentStatus new_status = 2;
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.prototype.getNewStatus = function() {
  return /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest.prototype.setNewStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    experiment: (f = msg.getExperiment()) && proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.deserializeBinaryFromReader);
      msg.setExperiment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExperiment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Experiment experiment = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.prototype.getExperiment = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.prototype.setExperiment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.prototype.clearExperiment = function() {
  return this.setExperiment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.prototype.hasExperiment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    experimentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    from: jspb.Message.getFieldWithDefault(msg, 2, 0),
    to: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExperimentId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFrom(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExperimentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFrom();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTo();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string experiment_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.prototype.getExperimentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.prototype.setExperimentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 from = 2;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.prototype.getFrom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.prototype.setFrom = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 to = 3;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.prototype.getTo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest.prototype.setTo = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.repeatedFields_ = [5,6,13,30,31];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    experiment: (f = msg.getExperiment()) && proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.toObject(includeInstance, f),
    verdict: jspb.Message.getFieldWithDefault(msg, 2, 0),
    scenarioA: (f = msg.getScenarioA()) && proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.toObject(includeInstance, f),
    scenarioB: (f = msg.getScenarioB()) && proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.toObject(includeInstance, f),
    tableList: jspb.Message.toObjectList(msg.getTableList(),
    proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.toObject, includeInstance),
    seriesList: jspb.Message.toObjectList(msg.getSeriesList(),
    proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.toObject, includeInstance),
    activeDays: jspb.Message.getFieldWithDefault(msg, 7, 0),
    remainingDays: jspb.Message.getFieldWithDefault(msg, 8, 0),
    hasRemainingDays: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    minBookingsReached: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    minBookingsThreshold: jspb.Message.getFieldWithDefault(msg, 11, 0),
    partial: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    warningsList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
    pausedSeconds: jspb.Message.getFieldWithDefault(msg, 14, 0),
    confidence: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
    pValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
    srmPValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
    srmAlert: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    expectedShareA: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
    observedShareA: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
    requiredVisitors: jspb.Message.getFieldWithDefault(msg, 21, 0),
    sampleProgress: jspb.Message.getFloatingPointFieldWithDefault(msg, 22, 0.0),
    estimatedDaysLeft: jspb.Message.getFieldWithDefault(msg, 23, 0),
    hasEstimatedDaysLeft: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    mde: jspb.Message.getFieldWithDefault(msg, 25, 0),
    minDays: jspb.Message.getFieldWithDefault(msg, 26, 0),
    dataUntil: jspb.Message.getFieldWithDefault(msg, 27, ""),
    source: jspb.Message.getFieldWithDefault(msg, 28, ""),
    isReliable: jspb.Message.getBooleanFieldWithDefault(msg, 29, false),
    segmentsList: jspb.Message.toObjectList(msg.getSegmentsList(),
    proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.toObject, includeInstance),
    pausesList: jspb.Message.toObjectList(msg.getPausesList(),
    proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.toObject, includeInstance),
    lift: jspb.Message.getFloatingPointFieldWithDefault(msg, 32, 0.0),
    liftCiLow: jspb.Message.getFloatingPointFieldWithDefault(msg, 33, 0.0),
    liftCiHigh: jspb.Message.getFloatingPointFieldWithDefault(msg, 34, 0.0),
    hasLiftCi: jspb.Message.getBooleanFieldWithDefault(msg, 35, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.deserializeBinaryFromReader);
      msg.setExperiment(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.Verdict} */ (reader.readEnum());
      msg.setVerdict(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.deserializeBinaryFromReader);
      msg.setScenarioA(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.deserializeBinaryFromReader);
      msg.setScenarioB(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.deserializeBinaryFromReader);
      msg.addTable(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.deserializeBinaryFromReader);
      msg.addSeries(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActiveDays(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRemainingDays(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasRemainingDays(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMinBookingsReached(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinBookingsThreshold(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPartial(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addWarnings(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPausedSeconds(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConfidence(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPValue(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSrmPValue(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSrmAlert(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExpectedShareA(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setObservedShareA(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRequiredVisitors(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSampleProgress(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstimatedDaysLeft(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasEstimatedDaysLeft(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMde(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinDays(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataUntil(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsReliable(value);
      break;
    case 30:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.deserializeBinaryFromReader);
      msg.addSegments(value);
      break;
    case 31:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.deserializeBinaryFromReader);
      msg.addPauses(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLift(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLiftCiLow(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLiftCiHigh(value);
      break;
    case 35:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasLiftCi(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExperiment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment.serializeBinaryToWriter
    );
  }
  f = message.getVerdict();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getScenarioA();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.serializeBinaryToWriter
    );
  }
  f = message.getScenarioB();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.serializeBinaryToWriter
    );
  }
  f = message.getTableList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.serializeBinaryToWriter
    );
  }
  f = message.getSeriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.serializeBinaryToWriter
    );
  }
  f = message.getActiveDays();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getRemainingDays();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getHasRemainingDays();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getMinBookingsReached();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getMinBookingsThreshold();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getPartial();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getWarningsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getPausedSeconds();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getConfidence();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getPValue();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getSrmPValue();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getSrmAlert();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getExpectedShareA();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getObservedShareA();
  if (f !== 0.0) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getRequiredVisitors();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getSampleProgress();
  if (f !== 0.0) {
    writer.writeDouble(
      22,
      f
    );
  }
  f = message.getEstimatedDaysLeft();
  if (f !== 0) {
    writer.writeInt32(
      23,
      f
    );
  }
  f = message.getHasEstimatedDaysLeft();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getMde();
  if (f !== 0) {
    writer.writeInt32(
      25,
      f
    );
  }
  f = message.getMinDays();
  if (f !== 0) {
    writer.writeInt32(
      26,
      f
    );
  }
  f = message.getDataUntil();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getIsReliable();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
  f = message.getSegmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      30,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.serializeBinaryToWriter
    );
  }
  f = message.getPausesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      31,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.serializeBinaryToWriter
    );
  }
  f = message.getLift();
  if (f !== 0.0) {
    writer.writeDouble(
      32,
      f
    );
  }
  f = message.getLiftCiLow();
  if (f !== 0.0) {
    writer.writeDouble(
      33,
      f
    );
  }
  f = message.getLiftCiHigh();
  if (f !== 0.0) {
    writer.writeDouble(
      34,
      f
    );
  }
  f = message.getHasLiftCi();
  if (f) {
    writer.writeBool(
      35,
      f
    );
  }
};


/**
 * optional Experiment experiment = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getExperiment = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.experiment.v1.Experiment|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setExperiment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.clearExperiment = function() {
  return this.setExperiment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.hasExperiment = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Verdict verdict = 2;
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Verdict}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getVerdict = function() {
  return /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.Verdict} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.Verdict} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setVerdict = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ScenarioMetrics scenario_a = 3;
 * @return {?proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getScenarioA = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics, 3));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setScenarioA = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.clearScenarioA = function() {
  return this.setScenarioA(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.hasScenarioA = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ScenarioMetrics scenario_b = 4;
 * @return {?proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getScenarioB = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics, 4));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setScenarioB = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.clearScenarioB = function() {
  return this.setScenarioB(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.hasScenarioB = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated MetricComparison table = 5;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison>}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getTableList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison, 5));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison>} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setTableList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.addTable = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.clearTableList = function() {
  return this.setTableList([]);
};


/**
 * repeated TimeSeriesPoint series = 6;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint>}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getSeriesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint, 6));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint>} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setSeriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.addSeries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.clearSeriesList = function() {
  return this.setSeriesList([]);
};


/**
 * optional int32 active_days = 7;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getActiveDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setActiveDays = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 remaining_days = 8;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getRemainingDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setRemainingDays = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool has_remaining_days = 9;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getHasRemainingDays = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setHasRemainingDays = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool min_bookings_reached = 10;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getMinBookingsReached = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setMinBookingsReached = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional int32 min_bookings_threshold = 11;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getMinBookingsThreshold = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setMinBookingsThreshold = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional bool partial = 12;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getPartial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setPartial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * repeated string warnings = 13;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getWarningsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setWarningsList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.addWarnings = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.clearWarningsList = function() {
  return this.setWarningsList([]);
};


/**
 * optional int64 paused_seconds = 14;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getPausedSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setPausedSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional double confidence = 15;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double p_value = 16;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getPValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setPValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional double srm_p_value = 17;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getSrmPValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setSrmPValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional bool srm_alert = 18;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getSrmAlert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setSrmAlert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional double expected_share_a = 19;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getExpectedShareA = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setExpectedShareA = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional double observed_share_a = 20;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getObservedShareA = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setObservedShareA = function(value) {
  return jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional int64 required_visitors = 21;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getRequiredVisitors = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setRequiredVisitors = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional double sample_progress = 22;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getSampleProgress = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setSampleProgress = function(value) {
  return jspb.Message.setProto3FloatField(this, 22, value);
};


/**
 * optional int32 estimated_days_left = 23;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getEstimatedDaysLeft = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setEstimatedDaysLeft = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional bool has_estimated_days_left = 24;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getHasEstimatedDaysLeft = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setHasEstimatedDaysLeft = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional int32 mde = 25;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getMde = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setMde = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int32 min_days = 26;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getMinDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setMinDays = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional string data_until = 27;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getDataUntil = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setDataUntil = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string source = 28;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional bool is_reliable = 29;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getIsReliable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setIsReliable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};


/**
 * repeated SegmentMetrics segments = 30;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics>}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getSegmentsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics, 30));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics>} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setSegmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 30, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.addSegments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 30, opt_value, proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.clearSegmentsList = function() {
  return this.setSegmentsList([]);
};


/**
 * repeated PausePeriod pauses = 31;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod>}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getPausesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod, 31));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod>} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setPausesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 31, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.addPauses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 31, opt_value, proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.clearPausesList = function() {
  return this.setPausesList([]);
};


/**
 * optional double lift = 32;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getLift = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 32, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setLift = function(value) {
  return jspb.Message.setProto3FloatField(this, 32, value);
};


/**
 * optional double lift_ci_low = 33;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getLiftCiLow = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 33, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setLiftCiLow = function(value) {
  return jspb.Message.setProto3FloatField(this, 33, value);
};


/**
 * optional double lift_ci_high = 34;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getLiftCiHigh = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 34, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setLiftCiHigh = function(value) {
  return jspb.Message.setProto3FloatField(this, 34, value);
};


/**
 * optional bool has_lift_ci = 35;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.getHasLiftCi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 35, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.prototype.setHasLiftCi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 35, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
    dimension: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, ""),
    scenarioA: (f = msg.getScenarioA()) && proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.toObject(includeInstance, f),
    scenarioB: (f = msg.getScenarioB()) && proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.toObject(includeInstance, f),
    confidence: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    liftPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    smallSample: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDimension(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.deserializeBinaryFromReader);
      msg.setScenarioA(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.deserializeBinaryFromReader);
      msg.setScenarioB(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConfidence(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLiftPct(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSmallSample(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDimension();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getScenarioA();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.serializeBinaryToWriter
    );
  }
  f = message.getScenarioB();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.serializeBinaryToWriter
    );
  }
  f = message.getConfidence();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getLiftPct();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getSmallSample();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string dimension = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.getDimension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.setDimension = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ScenarioMetrics scenario_a = 3;
 * @return {?proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.getScenarioA = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics, 3));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.setScenarioA = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.clearScenarioA = function() {
  return this.setScenarioA(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.hasScenarioA = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ScenarioMetrics scenario_b = 4;
 * @return {?proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.getScenarioB = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics, 4));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.setScenarioB = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.clearScenarioB = function() {
  return this.setScenarioB(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.hasScenarioB = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional double confidence = 5;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.getConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double lift_pct = 6;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.getLiftPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.setLiftPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional bool small_sample = 7;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.getSmallSample = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.SegmentMetrics.prototype.setSmallSample = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: jspb.Message.getFieldWithDefault(msg, 1, 0),
    to: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTo();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 from = 1;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.prototype.getFrom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.prototype.setFrom = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 to = 2;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.prototype.getTo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.PausePeriod.prototype.setTo = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
    variantId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    variantTicker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    role: jspb.Message.getFieldWithDefault(msg, 3, 0),
    visits: jspb.Message.getFieldWithDefault(msg, 4, 0),
    bookings: jspb.Message.getFieldWithDefault(msg, 5, 0),
    conversionRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    revenueTotal: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    revenuePerVisit: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    adr: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    avgBookingValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    abandonmentRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    currency: jspb.Message.getFieldWithDefault(msg, 12, ""),
    validVisitors: jspb.Message.getFieldWithDefault(msg, 13, 0),
    excludedVisitors: jspb.Message.getFieldWithDefault(msg, 14, 0),
    ciLow: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
    ciHigh: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
    botSuspectVisitors: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVariantId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVariantTicker(value);
      break;
    case 3:
      var value = /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.VariantRole} */ (reader.readEnum());
      msg.setRole(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setVisits(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBookings(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConversionRate(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRevenueTotal(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRevenuePerVisit(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAdr(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgBookingValue(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAbandonmentRate(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValidVisitors(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExcludedVisitors(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCiLow(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCiHigh(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBotSuspectVisitors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVariantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVariantTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getVisits();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getBookings();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getConversionRate();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getRevenueTotal();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getRevenuePerVisit();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getAdr();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getAvgBookingValue();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getAbandonmentRate();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getValidVisitors();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getExcludedVisitors();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getCiLow();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getCiHigh();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getBotSuspectVisitors();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
};


/**
 * optional string variant_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getVariantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setVariantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string variant_ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getVariantTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setVariantTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional VariantRole role = 3;
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.VariantRole}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getRole = function() {
  return /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.VariantRole} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.VariantRole} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 visits = 4;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getVisits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setVisits = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 bookings = 5;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getBookings = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setBookings = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double conversion_rate = 6;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getConversionRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setConversionRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double revenue_total = 7;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getRevenueTotal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setRevenueTotal = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double revenue_per_visit = 8;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getRevenuePerVisit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setRevenuePerVisit = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double adr = 9;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getAdr = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setAdr = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double avg_booking_value = 10;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getAvgBookingValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setAvgBookingValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double abandonment_rate = 11;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getAbandonmentRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setAbandonmentRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional string currency = 12;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 valid_visitors = 13;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getValidVisitors = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setValidVisitors = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 excluded_visitors = 14;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getExcludedVisitors = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setExcludedVisitors = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional double ci_low = 15;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getCiLow = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setCiLow = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double ci_high = 16;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getCiHigh = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setCiHigh = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional int64 bot_suspect_visitors = 17;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.getBotSuspectVisitors = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ScenarioMetrics.prototype.setBotSuspectVisitors = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.toObject = function(includeInstance, msg) {
  var f, obj = {
    metricKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    valueA: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    valueB: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    winner: jspb.Message.getFieldWithDefault(msg, 4, ""),
    relativeDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    diffUnit: jspb.Message.getFieldWithDefault(msg, 6, 0),
    higherIsBetter: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetricKey(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValueA(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValueB(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setWinner(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRelativeDiff(value);
      break;
    case 6:
      var value = /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.DiffUnit} */ (reader.readEnum());
      msg.setDiffUnit(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHigherIsBetter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetricKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValueA();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getValueB();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getWinner();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRelativeDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getDiffUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getHigherIsBetter();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string metric_key = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.getMetricKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.setMetricKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double value_a = 2;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.getValueA = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.setValueA = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double value_b = 3;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.getValueB = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.setValueB = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string winner = 4;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.getWinner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.setWinner = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double relative_diff = 5;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.getRelativeDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.setRelativeDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional DiffUnit diff_unit = 6;
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.DiffUnit}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.getDiffUnit = function() {
  return /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.DiffUnit} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.DiffUnit} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.setDiffUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional bool higher_is_better = 7;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.getHigherIsBetter = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.MetricComparison.prototype.setHigherIsBetter = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
    bucketStart: jspb.Message.getFieldWithDefault(msg, 1, 0),
    labelKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    metricsMap: (f = msg.getMetricsMap()) ? f.toObject(includeInstance, proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.toObject) : [],
    granularity: jspb.Message.getFieldWithDefault(msg, 4, 0),
    bucketEnd: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBucketStart(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabelKey(value);
      break;
    case 3:
      var value = msg.getMetricsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.deserializeBinaryFromReader, "", new proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue());
         });
      break;
    case 4:
      var value = /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.Granularity} */ (reader.readEnum());
      msg.setGranularity(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBucketEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucketStart();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getLabelKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMetricsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.serializeBinaryToWriter);
  }
  f = message.getGranularity();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getBucketEnd();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 bucket_start = 1;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.prototype.getBucketStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.prototype.setBucketStart = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string label_key = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.prototype.getLabelKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.prototype.setLabelKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<string, TimeSeriesMetricValue> metrics = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue>}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.prototype.getMetricsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.prototype.clearMetricsMap = function() {
  this.getMetricsMap().clear();
  return this;};


/**
 * optional Granularity granularity = 4;
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.Granularity}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.prototype.getGranularity = function() {
  return /** @type {!proto.witbooking.backoffice.orchestrator.experiment.v1.Granularity} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.Granularity} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.prototype.setGranularity = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 bucket_end = 5;
 * @return {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.prototype.getBucketEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesPoint.prototype.setBucketEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    a: (f = msg.getA()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
    b: (f = msg.getB()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
    ciLowA: (f = msg.getCiLowA()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
    ciHighA: (f = msg.getCiHighA()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
    ciLowB: (f = msg.getCiLowB()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
    ciHighB: (f = msg.getCiHighB()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setA(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setB(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setCiLowA(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setCiHighA(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setCiLowB(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setCiHighB(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getA();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getB();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCiLowA();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCiHighA();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCiLowB();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCiHighB();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.DoubleValue a = 1;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.getA = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 1));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.setA = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.clearA = function() {
  return this.setA(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.hasA = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.DoubleValue b = 2;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.getB = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 2));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.setB = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.clearB = function() {
  return this.setB(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.hasB = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.DoubleValue ci_low_a = 3;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.getCiLowA = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 3));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.setCiLowA = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.clearCiLowA = function() {
  return this.setCiLowA(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.hasCiLowA = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.DoubleValue ci_high_a = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.getCiHighA = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.setCiHighA = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.clearCiHighA = function() {
  return this.setCiHighA(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.hasCiHighA = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue ci_low_b = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.getCiLowB = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.setCiLowB = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.clearCiLowB = function() {
  return this.setCiLowB(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.hasCiLowB = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue ci_high_b = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.getCiHighB = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} returns this
*/
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.setCiHighB = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.clearCiHighB = function() {
  return this.setCiHighB(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.TimeSeriesMetricValue.prototype.hasCiHighB = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    experimentId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExperimentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExperimentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string experiment_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest.prototype.getExperimentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest.prototype.setExperimentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    csv: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse;
  return proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCsv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCsv();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string csv = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.prototype.getCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.prototype.setCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Granularity = {
  GRANULARITY_UNSPECIFIED: 0,
  GRANULARITY_DAY: 1,
  GRANULARITY_WEEK: 2
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.Verdict = {
  VERDICT_UNSPECIFIED: 0,
  VERDICT_COLLECTING: 1,
  VERDICT_NO_WINNER: 2,
  VERDICT_WINNER_A: 3,
  VERDICT_WINNER_B: 4
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.DiffUnit = {
  DIFF_UNIT_UNSPECIFIED: 0,
  DIFF_UNIT_PERCENT: 1
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentStatus = {
  EXPERIMENT_STATUS_UNSPECIFIED: 0,
  EXPERIMENT_STATUS_DRAFT: 1,
  EXPERIMENT_STATUS_RUNNING: 2,
  EXPERIMENT_STATUS_PAUSED: 3,
  EXPERIMENT_STATUS_ARCHIVED: 4
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.VariantType = {
  VARIANT_TYPE_UNSPECIFIED: 0,
  VARIANT_TYPE_SCENARIO: 1,
  VARIANT_TYPE_URL: 2
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.VariantRole = {
  VARIANT_ROLE_UNSPECIFIED: 0,
  VARIANT_ROLE_CONTROL: 1,
  VARIANT_ROLE_VARIANT: 2
};

goog.object.extend(exports, proto.witbooking.backoffice.orchestrator.experiment.v1);
